import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const options = {
  chart: {
    type: 'spline'
  },
  title: {
    text: 'My chart'
  },
  series: [
    {
      data: [1, 2, 1, 4, 3, 6]
    }
  ]
};

class Userstatistic extends Component {

  componentWillMount(){
    // let sftp = new Client();
    // sftp.connect({
    //   host: '20.102.57.108',
    //   port: '22',
    //   username: "xqftpuser",
    //   password: "Sementara#3#",
    //   algorithms: {
    //     serverHostKey: [ 'hmac-sha2-256', 'hmac-sha2-512', 'hmac-sha1', 'hmac-sha1-96' ],
    //   }
    // }).then(() => {
    //   return sftp.list('/home/xqftpuser');
    // }).then(data => {
    //   console.log(data, 'the data info');
    // }).catch(err => {
    //   console.log(err, 'catch error');
    // });
  }

  render() {
    return (
      <Card>
        <CardBody>
          <GridContainer>
            <HighchartsReact highcharts={Highcharts} options={options} />
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}

export default Userstatistic;
